import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import AttachMoney from "@material-ui/icons/AttachMoney";
import TagFaces from "@material-ui/icons/TagFaces";
import Check from "@material-ui/icons/Check";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from "@material-ui/core/FormControl";

import SweetAlert from "react-bootstrap-sweetalert";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import axios from 'axios';
import { API_ROOT } from 'api-config';
import { getApiHeaders, handleApiResponse } from '../../assets/helpers/apiHelper.jsx';
import { simulateMouseClick } from '../../assets/helpers/formHelper.jsx';
import { convertToDisplayDate } from '../../assets/helpers/dataHelper';
import {
  cirrusOrangeColor
} from "assets/jss/material-dashboard-pro-react.jsx";
import { getCreditCardFeeDisplay, lineSplitToObject } from "../../assets/helpers/displayHelper";
var moment = require('moment');
const style = {
  cardCategory: {
    color: "#999999",
    marginTop: "10px"
  },
  icon: {
    color: "#333333",
    margin: "10px auto 0",
    width: "130px",
    height: "130px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    lineHeight: "174px",
    "& svg": {
      width: "55px",
      height: "55px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "55px",
      fontSize: "55px"
    }
  },
  iconcirrusOrange: {
    color: cirrusOrangeColor
  },
  marginTop30: {
    marginTop: "30px"
  },
  subscriptionDetails: {
    margin: "25px",
    padding: "15px",
    width: "300px",
    height: "300px",
    overflow: "auto"
  },
  ...sweetAlertStyle,
  ...regularFormsStyle,
  ...userProfileStyles
};

class Subscriptions extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = ''
    var providerId = ''
    var chooseSubscriptionAdditionalText = ''
    var showCardIcon = true
    var cardTitle = 'Change Subscription'
    var cardSubtitle = 'update your monthly subscription'
    var saveSelection = true
    var employerId = ''
    var waitForEmployerId = false
    var allowMonthlyPlans = false
    var allowAnnualPlans = false
    var getMemberPlanInfo = true
    if (props.userId) {
      userId = props.userId
    } else {
      userId = sessionStorage.getItem('userId')
    }
    if (props.providerId) {
      providerId = props.providerId
      if (!props.standardSelectText) {
        chooseSubscriptionAdditionalText = 'and change provider'
      }
    }

    if (props.showCardIcon || props.showCardIcon === false) {
      showCardIcon = props.showCardIcon
    }

    if (props.saveSelection || props.saveSelection === false) {
      saveSelection = props.saveSelection
    }

    if (props.cardTitle) {
      cardTitle = props.cardTitle
    }
    if (props.cardSubtitle) {
      cardSubtitle = props.cardSubtitle
    }
    var editByOrg = false
    var isPatient = '1'
    var viewType;
    if (props.editByOrg && props.editByOrg === true) {
      editByOrg = true
      isPatient = '0'
    }
    if (props.viewType) {
      viewType = props.viewType
    }
    if (props.employerId) {
      employerId = props.employerId
    }
    if (props.waitForEmployerId) {
      waitForEmployerId = props.waitForEmployerId
    }
    if (props.allowMonthlyPlans) {
      allowMonthlyPlans = props.allowMonthlyPlans
    }
    if (props.allowAnnualPlans) {
      allowAnnualPlans = props.allowAnnualPlans
    }
    if (props.hasOwnProperty('getMemberPlanInfo')) {
      getMemberPlanInfo = props.getMemberPlanInfo
    }

    const chargeCreditCardFee = this.props.chargeCreditCardFee ? this.props.chargeCreditCardFee : false;
    const creditCardFee = this.props.creditCardFee ? this.props.creditCardFee : 'false';

    var selectedPlanType = this.pickSelectedPlanType(allowMonthlyPlans, allowAnnualPlans)
    this.onSubmitPlan = this.onSubmitPlan.bind(this);
    this.state = {
      userId: userId,
      selectedPlanId: '',
      selectedPlanType: selectedPlanType,
      plans: [],
      editByOrg: editByOrg,
      subscriptionDetails: '',
      subscriptionDetailsOpen: false,
      anchorEl: null,
      providerId: providerId,
      chooseSubscriptionAdditionalText: chooseSubscriptionAdditionalText,
      showCardIcon: showCardIcon,
      cardTitle: cardTitle,
      cardSubtitle: cardSubtitle,
      saveSelection: saveSelection,
      isPatient: isPatient,
      patientHasHiddenPlan: false,
      alert: '',
      viewType: viewType,
      selectedPlans: [],
      employerId: employerId,
      waitForEmployerId: waitForEmployerId,
      allowMonthlyPlans: allowMonthlyPlans,
      allowAnnualPlans: allowAnnualPlans,
      showPlanType: selectedPlanType,
      getMemberPlanInfo: getMemberPlanInfo,
      allowSavings: false,
      savingsAmountMin: '',
      savingsAmountMax: '',
      savingsAmount: 0,
      savingsAmountList: [0],
      savingsBonus: 0,
      chargeCreditCardFee: chargeCreditCardFee,
      creditCardFee: creditCardFee
    }
  }
  
  pickSelectedPlanType(allowMonthlyPlans, allowAnnualPlans) {
    var selectedPlanType = 'M'
    if (!allowMonthlyPlans || !allowAnnualPlans) {
      if (allowMonthlyPlans) {
        selectedPlanType = 'M'
      } else if (allowAnnualPlans) {
        selectedPlanType = 'A'
      }
    }
    return selectedPlanType
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeSavingsAmount = event => {
    if (typeof this.props.onSelectSavingsAmount === 'function') {
      this.props.onSelectSavingsAmount(event.target.value);
    }
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleViewSubscriptionDetails(event, subscriptionDetails) {
    this.setState({
      subscriptionDetails: subscriptionDetails,
      subscriptionDetailsOpen: true,
      anchorEl: event.currentTarget
    });
  }

  handleCloseSubscriptionDetails = event => {
    this.setState({
      subscriptionDetails: '',
      subscriptionDetailsOpen: false,
      anchorEl: null
    });
  }

  onSubmitPlan(planId, planType) {
    const planData = {
      userId: this.state.userId,
      planId: planId,
      planType: planType,
      savingsAmount: this.state.savingsAmount
    }
    axios.post(`${API_ROOT}/plan/`, planData, {headers: getApiHeaders()})
      .then(res => this.handleSubmitPlan(res));
  }

  handleSubmitPlan(res) {
    handleApiResponse(res)
    if (this.props.onPlanUpdate) {
      this.props.onPlanUpdate(this.state.providerId, this.props.updateAction, this.props.isPrimary)
    }
    if (this.props.onPlanUpdateSetPlanId) {
      this.props.onPlanUpdateSetPlanId(this.state.selectedPlanId)
    }
  }


  componentDidMount() {
    this._isMounted = true;
    // get the plan information only if we are not waiting for an employerId to be set from the parent
    if (!this.state.waitForEmployerId) {
      if (this.state.providerId || this.state.employerId) {
        this.getPlanInfo()
      } else if (this.state.getMemberPlanInfo) {
        this.lookupPlanProvider()
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // if the employerId is updated in the props, clear the providerId
  // and get the plan info for that employerId
  // we need to pass the employerId rather than relaying on the state in the get because the state may not be set by the time the get triggers
  static getDerivedStateFromProps(nextProps, prevState){
    if (prevState.employerId !== nextProps.employerId && nextProps.employerId && nextProps.employerId !== 'none' && !nextProps.waitForEmployerId) {
      return { employerId: nextProps.employerId};
    }
    else return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.employerId!==this.props.employerId){
      this.setState({
        employerId: this.props.employerId,
        providerId: '',
        plans: []
      });
      this.getPlanInfo(this.props.employerId)
      if (this.state.getMemberPlanInfo && this.props.employerId === 'none') {
        this.lookupPlanProvider()
      }
    }
    if(prevProps.providerId!==this.props.providerId){
      this.setState({
        providerId: this.props.providerId
      });
      this.getPlanInfo('', this.props.providerId)
    }

    if(prevProps.paymentMethod!==this.props.paymentMethod){
      this.setState({
        paymentMethod: this.props.paymentMethod
      });
    }
    if(prevProps.chargeCreditCardFee!==this.props.chargeCreditCardFee){
      this.setState({
        chargeCreditCardFee: this.props.chargeCreditCardFee
      });
    }

    if(prevProps.creditCardFee!==this.props.creditCardFee){
      this.setState({
        creditCardFee: this.props.creditCardFee
      });
    }
    if (prevProps.allowMonthlyPlans!==this.props.allowMonthlyPlans || prevProps.allowAnnualPlans!==this.props.allowAnnualPlans) {
      var showPlanType = this.pickSelectedPlanType(this.props.allowMonthlyPlans, this.props.allowAnnualPlans)
      this.setState({
        allowMonthlyPlans: this.props.allowMonthlyPlans,
        allowAnnualPlans: this.props.allowAnnualPlans,
        showPlanType: showPlanType
      })
    }
  }

  lookupPlanProvider() {
    //look up the dentist
    axios.get(`${API_ROOT}/provider/?userId=`+this.state.userId+`&isPrimary=1`, {headers: getApiHeaders()})
      .then(res => this.setPlanProvider({responseMessage: res.data}));

  }

  setPlanProvider(res) {
    if (this._isMounted) {
      const responseMessage = res.responseMessage;
      var providerId = '';
      var allowMonthlyPlans = '';
      var allowAnnualPlans = '';
      var chargeCreditCardFee = '';
      var creditCardFee = '';
      if (res.responseMessage.length > 0) {
        providerId = responseMessage[0]['userId'];
        allowMonthlyPlans = responseMessage[0]['allowMonthlyPlans'];
        allowAnnualPlans = responseMessage[0]['allowAnnualPlans'];
        chargeCreditCardFee = responseMessage[0]['chargeCreditCardFee'];
        creditCardFee = responseMessage[0]['creditCardFee'];
      }
      var selectedPlanType = this.pickSelectedPlanType(allowMonthlyPlans, allowAnnualPlans);
      this.setState({
        providerId: providerId,
        allowMonthlyPlans: allowMonthlyPlans,
        allowAnnualPlans: allowAnnualPlans,
        selectedPlanType: selectedPlanType,
        showPlanType: selectedPlanType,
        chargeCreditCardFee: chargeCreditCardFee,
        creditCardFee: creditCardFee
      });
      this.getPlanInfo();
    }
  }

  getPlanInfo(employerId = '', userId = '') {
    if (this._isMounted) {
      if ((!employerId || employerId === 'none') && this.state.employerId !== 'none') {
        employerId = this.state.employerId
      }
      //need to use a passed param to deal with race condition
      if (!userId || userId === 'none') {
        userId = this.state.providerId
      }
      // if we have an employer ID to use to look up the plans, don't send a user ID
      // in the API, the user ID overrides the employer ID
      if (employerId !== '') {
        userId = ''
      }
      let params = `?userId=` + userId + `&isPatient=` + this.state.isPatient + `&employerId=` + employerId;
      if (this.state.getMemberPlanInfo) {
        params += `&patientId=` + this.state.userId
      }
      axios.get(`${API_ROOT}/planOptions/` + params, { headers: getApiHeaders() })
        .then(res => this.setPlanInfo({ responseMessage: res.data }));
      axios.get(`${API_ROOT}/savingsOptions/?userId=` + userId, { headers: getApiHeaders() })
        .then(res => this.setSavingsInfo({ responseMessage: res.data }));
    }
  }


  getHiddenPlanInfo(planId) {
    if (this._isMounted) {
      axios.get(`${API_ROOT}/planOptions/?planId=` + planId, { headers: getApiHeaders() })
        .then(res => this.setHiddenPlanInfo({ responseMessage: res.data }));
    }
  }

  setPlanInfo(res) {
    if (this._isMounted) {
      this.setState({
        plans: res.responseMessage
      })
      if (this.state.viewType === 'employer') {
        this.getEmployerPlans()
      } else if (this.state.getMemberPlanInfo) {
        axios.get(`${API_ROOT}/plan/?userId=` + this.state.userId, { headers: getApiHeaders() })
          .then(res => this.setPlan({ responseMessage: res }));
      }
    }
  }

  setSavingsInfo(res) {
    if (!res.responseMessage.error) {
      const savingsAmountList = []
      var savingsAmount;
      for (savingsAmount = Math.round(res.responseMessage.savingsAmountMin); savingsAmount <= Math.round(res.responseMessage.savingsAmountMax); savingsAmount++) {
        savingsAmountList.push(savingsAmount)
      }
      this.setState({
        allowSavings: res.responseMessage.allowSavings,
        savingsAmountMin: res.responseMessage.savingsAmountMin,
        savingsAmountMax: res.responseMessage.savingsAmountMax,
        savingsAmountList: savingsAmountList,
        savingsBonus: res.responseMessage.savingsBonus
      })
    }
  }

  setHiddenPlanInfo(res) {
    if (!this.state.patientHasHiddenPlan) { // we need to do this check here rather than before the associated API call,
      // otherwise a race condition may allow two API calls before the hidden plan is set
      var tempPlans = this.state.plans
      tempPlans.push(res.responseMessage[0])
      this.setState({
        plans: tempPlans,
        patientHasHiddenPlan: true
      })
    }
  }

  setPlan(res) {
    if (this._isMounted) {
      var planData = res.responseMessage.data
      if (planData['plan_id']) {
        // if the plan is not in the options already return, get the details about this plan
        // this would be the case if the dentist marked the plan as do not display
        var planIsDisplayed = false
        for (var i = 0; i < this.state.plans.length; ++i) {
          if (this.state.plans[i]['id'] === planData['plan_id']) {
            planIsDisplayed = true
          }
        }
        if (planIsDisplayed === false) {
          this.getHiddenPlanInfo(planData['plan_id'])
        }
        this.selectPlan(planData['plan_id'], planData['planType'], false)
      }
      this.selectSavingsAmount(planData['savingsAmount'])
    }
  }

  selectPlan(planId, planType, saveChange, overrideWarning) {
    var setVars = true
    if (saveChange) {
      if (this.state.patientHasHiddenPlan && overrideWarning !== true) {
        setVars = false
        this.setState({
          alert: (
            <SweetAlert
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title="Are you sure?"
              onConfirm={() => this.selectPlan(planId, planType, saveChange, true)}
              onCancel={() => this.hideAlert()}
              confirmBtnCssClass={
                this.props.classes.button + " " + this.props.classes.success
              }
              cancelBtnCssClass={
                this.props.classes.button + " " + this.props.classes.danger
              }
              confirmBtnText="Yes, switch subscription"
              cancelBtnText="Cancel"
              confirmBtnId="confirmButtonId"
              showCancel
            >
              <span id="changeSubscriptionAlertText">Your current plan is not publicly displayed to patients. If you switch to a new plan,
              you will need to contact your dentist to switch back.
                Are you sure you want to switch?</span>
            </SweetAlert>
          )
        });
      } else {
        this.onSubmitPlan(planId, planType)
      }
    }
    if (setVars) {
      var showPlanType;
      //if the dentist does not allow both monthly and annual plans, set the option that shows as the one the dentist allows
      //do this only if the user is not saving a change - if they are saving a change, show the plan type they are saving
      //if there is an external onSelectPlan, consider that as saving the plan
      //if the dentist allows both, set the showing plan type as the one the patient has
      if ((!this.state.allowMonthlyPlans || !this.state.allowAnnualPlans) && !saveChange && typeof this.props.onSelectPlan !== 'function') {
        showPlanType = this.state.selectedPlanType
      } else {
        showPlanType = planType
      }
      this.setState({
        selectedPlanId: planId,
        selectedPlanType: planType,
        showPlanType: showPlanType
      })
      if (overrideWarning) {
        this.setState({
          patientHasHiddenPlan: false
        })
      }
      if (typeof this.props.onSelectPlan === 'function') {
        this.props.onSelectPlan(planId, planType);
      }
      if (typeof this.props.onPlanUpdateSetPlanId === 'function') {
        this.props.onPlanUpdateSetPlanId(this.state.selectedPlanId)
      }
      this.hideAlert()
    }
  }

  selectSavingsAmount(savingsAmount) {
    this.setState({
      savingsAmount: Math.round(savingsAmount)
    })
  }

  updateSavingsAmount() {
    this.onSubmitPlan(this.state.selectedPlanId, this.state.selectedPlanType)
  }

  getEmployerPlans() {
    axios.get(`${API_ROOT}/employerPlans/?userId=` + this.state.userId, { headers: getApiHeaders() })
      .then(res => this.setEmployerPlans({ responseMessage: res }));
  }

  setEmployerPlans(res) {
    if (res.responseMessage.data) {
      var planId
      const planData = res.responseMessage.data
      for (var i = 0; i < planData.length; i++) {
        planId=planData[i]['plan_id']
        simulateMouseClick(document.getElementById('subscriptionCheckbox_' + planId))

      }
    }
  }

  handlePlanSelectedChange = (planId) => (event) => {
    var updateAction;
    if (event.target.checked) {
      updateAction = 'add'
    } else {
      updateAction = 'remove'
    }
    const planData = {
      userId: this.state.userId,
      planId: planId,
      updateAction: updateAction
    }
    axios.post(`${API_ROOT}/employerPlans/`, planData, { headers: getApiHeaders() })
      .then(res => handleApiResponse(res));
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  togglePlanType() {
    var newPlanType;
    if (this.state.showPlanType === 'M') {
      newPlanType = 'A'
    } else {
      newPlanType = 'M'
    }
    this.setState({
      showPlanType: newPlanType
    });
  }

  getNextChargeDate(numMonthsOut) {
    var dateObject = moment(new Date());
    dateObject.add(numMonthsOut, 'months');
    return dateObject.format("MM/01/YYYY");
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.alert}
            <CardHeader color="cirrusBlue" icon>
              <span style={this.state.showCardIcon ? {} : { display: 'none' }} >
                <CardIcon color="cirrusBlue">
                  <AttachMoney style={this.state.viewType === 'employer' ? { display: 'none' } : {}} />
                  <AssignmentTurnedIn style={this.state.viewType === 'employer' ? {} : { display: 'none' }} />
                </CardIcon>
              </span>
              <h4 className={classes.cardIconTitle}>
                {this.state.cardTitle} - <small>{this.state.cardSubtitle}</small>
              </h4>
            </CardHeader>

            <CardBody>
              <GridContainer justifyContent="center">
                <GridItem xs={12} sm={12} md={12} lg={12} style={this.state.allowMonthlyPlans && this.state.allowAnnualPlans ? {} : { display: 'none' }}>
                  monthly
                  <Switch
                    checked={this.state.showPlanType === 'A'}
                    onChange={this.togglePlanType.bind(this)}
                    value="allowChildAccess"
                    id="allowChildAccess"
                    classes={{
                      switchBase: classes.switchBase,
                      checked: classes.switchChecked
                    }}
                  />
                  annual
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <GridContainer>
                    {this.state.plans.map((plan, idx) => (
                      <GridItem sm={6} md={6} lg={6} xl={6} key={idx}>
                        <Card pricing id={"subscriptionCard_"+plan.id}>
                          <CardBody pricing>
                            <h6 className={classes.cardCategory} id={"subscriptionName_"+plan.id}>{plan.planName}</h6>
                            <div className={classes.icon}>
                              <TagFaces className={classes.iconcirrusOrange} />
                            </div>
                            <h3 className={`${classes.cardTitle} ${classes.marginTop30}`} style={this.state.showPlanType === 'M' ? {} : { display: 'none' }}>
                              ${plan.priceCurrent}/monthly
                            </h3>
                            <h3 className={`${classes.cardTitle} ${classes.marginTop30}`} style={this.state.showPlanType === 'A' ? {} : { display: 'none' }}>
                              ${plan.annualPriceCurrent}/yearly
                            </h3>
                            <small style={this.state.chargeCreditCardFee && this.state.paymentMethod === 'C' && this.state.showPlanType === 'M' ? {} : { display: 'none' }}>{getCreditCardFeeDisplay(this.state.creditCardFee, 'fee', plan.priceCurrent)}<br /></small>
                            <small style={this.state.chargeCreditCardFee && this.state.paymentMethod === 'C' && this.state.showPlanType === 'A' ? {} : { display: 'none' }}>{getCreditCardFeeDisplay(this.state.creditCardFee, 'fee', plan.annualPriceCurrent)}<br /></small>
                            <small style={this.state.showPlanType === 'M' && plan.initialChargeMonths === 0 ? {} : { display: 'none' }}>(We are prorating the first month and we'll charge ${plan.dueToday} today. Your monthly payments of ${plan.price} will start on {this.getNextChargeDate(1)}.)</small>

                            <div style={plan.priceChangeDate ? {} : { display: 'none' }}>
                              <small><em>
                              The price will increase to <span style={this.state.showPlanType === 'M' ? {} : { display: 'none' }}>${plan.price}/month</span> <span style={this.state.showPlanType === 'A' ? {} : { display: 'none' }}>${plan.annualPrice}/year</span> on {convertToDisplayDate(plan.priceChangeDate)}.
                              </em></small>
                            </div>
                            <span className={classes.cardDescription}>
                              {lineSplitToObject(plan.planDescription).map((textOfLine, key) =>
                                <p key={key}>{textOfLine.line}</p>
                              )}
                            </span>

                            <div className="actions-right">
                              {/* use this button to add a edit kind of action */}
                              <Button
                                size="sm"
                                simple
                                color="cirrusBlue"
                                onClick={(event) => this.handleViewSubscriptionDetails(event, plan.planTerms)}
                              >
                                more details
                              </Button>
                              <Popover
                                id="simple-popper"
                                open={this.state.subscriptionDetailsOpen}
                                anchorEl={this.state.anchorEl}
                                anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'center',
                                }}
                                transformOrigin={{
                                  vertical: 'top',
                                  horizontal: 'center',
                                }}
                                onClose={this.handleCloseSubscriptionDetails}
                              >
                                <Typography component={'span'} className={classes.subscriptionDetails}>
                                  {lineSplitToObject(this.state.subscriptionDetails).map((textOfLine, key) =>
                                    <p key={key}>{textOfLine.line}</p>
                                  )}
                                </Typography>
                              </Popover>
                              <p></p>
                              <span style={this.state.viewType === 'employer' ? { display: 'none' } : {}}>
                                <Button
                                  round
                                  onClick={this.selectPlan.bind(this, plan.id, this.state.showPlanType, this.state.saveSelection)}
                                  style={this.state.selectedPlanId === plan.id && this.state.selectedPlanType === this.state.showPlanType ? {backgroundColor: '#1a8db3'} : { backgroundColor: '#005692' }}
                                  id={"subscriptionButton_"+plan.id}
                                >
                                  <span style={this.state.selectedPlanId === plan.id && this.state.selectedPlanType === this.state.showPlanType ? { display: 'none' } : {}} >
                                    choose subscription
                                    <span style={this.state.chooseSubscriptionAdditionalText=== plan.id ? { display: 'none' } : {}} >
                                      <br /> {this.state.chooseSubscriptionAdditionalText}
                                    </span>
                                  </span>

                                  <span style={this.state.selectedPlanId === plan.id && this.state.selectedPlanType === this.state.showPlanType ? {} : { display: 'none' }} >
                                    selected
                                  </span>
                                </Button>{" "}
                              </span>
                              <span style={this.state.viewType === 'employer' ? {} : { display: 'none' }}>
                                <div className={classes.checkboxAndRadio}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        id={"subscriptionCheckbox_"+plan.id}
                                        tabIndex={-1}
                                        onClick={this.handlePlanSelectedChange(plan.id)}
                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                        icon={<Check className={classes.uncheckedIcon} />}
                                        classes={{
                                          checked: classes.checked,
                                          root: classes.checkRoot
                                        }}
                                      />
                                    }
                                    classes={{
                                      label: classes.label
                                    }}
                                    label="allow employees to enroll"
                                  />
                                </div>
                              </span>
                            </div>
                            <small style={this.state.showPlanType === 'M' && plan.initialChargeMonths && !plan.delayFirstMonthlyCharge ? {} : { display: 'none' }}><strong>Your first charge - processed today - will be ${plan.dueToday}.</strong> This will cover the rest of this month and also include an initial payment totaling {plan.initialChargeMonths} months. Your monthly payments of ${plan.price} will start on {this.getNextChargeDate(1)}.</small>
                            <small style={this.state.showPlanType === 'M' && plan.initialChargeMonths && plan.delayFirstMonthlyCharge ? {} : { display: 'none' }}><strong>Your first charge - processed today - will be ${plan.dueToday}.</strong> This will cover the rest of this month and the next {plan.initialChargeMonths} months. Your monthly payments of ${plan.price} will start on {this.getNextChargeDate(plan.initialChargeMonths+1)}.</small>

                          </CardBody>
                        </Card>
                      </GridItem>
                    ))}
                    <GridItem sm={6} md={6} lg={6} xl={6}  style={this.state.plans.length % 2 !== 0 ? {} : { display: 'none' }} >
                      <h3
                        className={`${classes.cardTitle} ${classes.marginTop30}`}
                      >
                        {/*need to have this text to make the spacer work - otherwise the single plan alternate this is squished*/}
                        <span style={{opacity: "0"}}> $30.00/monthly</span>
                      </h3>
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={12} style={this.state.allowSavings ? {} : { display: 'none' }}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      <span style={this.state.showPlanType === 'M' ? {} : { display: 'none' }}>Monthly </span><span style={this.state.showPlanType === 'A' ? {} : { display: 'none' }}>Annual </span>Nest Egg Amount
                    </InputLabel>
                    <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={this.state.savingsAmount}
                    onChange={this.handleChangeSavingsAmount}

                    inputProps={{
                      id: "savingsAmount",
                      name: "savingsAmount",
                      disabled: this.state.inputDisabled

                    }}

                  >
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem
                      }}
                      key='0' value='0'
                    >
                      no nest egg contribution
                    </MenuItem>
                    {this.state.savingsAmountList.map((savingsAmount) =>
                      <MenuItem classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }} key={savingsAmount} value={savingsAmount} ><span style={this.state.showPlanType === 'M' ? {} : { display: 'none' }}>${savingsAmount}/month</span><span style={this.state.showPlanType === 'A' ? {} : { display: 'none' }}>${savingsAmount * 12}/year</span></MenuItem>
                    )}

                  </Select>
                  </FormControl>
                  <Button
                    color="cirrusBlue"
                    id="updateSavingsAmountButton"
                    className={classes.updateProfileButton}
                    type="submit"
                    style={this.state.saveSelection ? {} : { display: 'none' }}
                    onClick={this.updateSavingsAmount.bind(this)}
                  >
                    Update Nest Egg
                  </Button>
                  <span style={this.state.editByOrg ? { display: 'none' } : {}}>Money contributed to your Nest Egg can be used to pay for any care not covered by the membership.
                    <span style={this.state.savingsBonus > 0 ? {} : { display: 'none' }}>&nbsp;We provide a {this.state.savingsBonus * 100}% bonus on Nest Egg contributions, meaning $100 is savings is worth ${100 + 100 *this.state.savingsBonus} in dental care.</span>
                     &nbsp;If you cancel your membership, we refund you 100% of any unused Nest Egg contributions.
                  </span>
                </GridItem>



              </GridContainer>
              <Clearfix />
            </CardBody>
      </div>
    )
  }
}

export default withStyles(style)(Subscriptions);